import { ENDPOINTS } from "../../utils/endPoints";
import {
  GET_API_CALL,
  PATCH_API_CALL,
  POST_API_CALL,
  POST_API_FILE_UPLOAD_CALL,
  PUT_API_CALL,
} from "../../utils/services";
import {
  UPDATE_CITIES_LIST,
  UPDATE_CITIES_LOADING,
} from "../../store/actionTypes";
import { createParams } from "../../utils/commonFunctions";
import toast from "react-hot-toast";

export const getCitiesList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_CITIES_LOADING });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().CityReducer;
    const params = createParams({
      pageNo,
      limit,
      searchKey,
      sortOrder,
      sortBy,
    });
    GET_API_CALL(ENDPOINTS.CITIES.CITIES_LIST, params, (response) => {
      console.log("Response :", response);
      if (response.isSuccess) {
        let { data, total } = response?.data;
        let totalPages = Math.ceil(total / limit);
        dispatch({
          type: UPDATE_CITIES_LIST,
          payload: {
            citiesList: data,
            total,
            totalPage: totalPages,
          },
        });
      }
      dispatch({ type: UPDATE_CITIES_LOADING });
    });
  };
};

export const getCityDetail = (cityId, callback) => {
  return () => {
    GET_API_CALL(
      ENDPOINTS.CITIES.CITY_DETAIL,
      `?cityId=${cityId}`,
      (response) => {
        console.log("City Detial Response :", response);
        if (response.isSuccess) {
          callback(response.data);
        } else callback(null);
      }
    );
  };
};

export const updateCity = (cityId, data ,callback) => {
  return () => {
    PUT_API_CALL(
      ENDPOINTS.CITIES.CITY_UPDATE + `?cityId=${cityId}`,
      data,
      (response) => {
        console.log("Update City Response :", response);
        if (response.isSuccess) {
          toast.success(response.data?.message);
          callback(response);
        }
      }
    );
  };
};
